export default "__VITE_ASSET__BTqi$6AA__"